import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { errorMessage } from "@/lib/api";
import { getDeregistrationCandidates, startDeregistration, type DeregistrationCandidate } from "@/lib/permitDeregistrations";

export function PermitDeregistrationBanner({ workerId, revision = 0 }: { workerId?: string; revision?: number }) {
  const { can } = useAuth();
  if (!can("dozvola", "read")) return null;
  return <BannerContent key={`${workerId ?? "all"}-${revision}`} workerId={workerId} />;
}

function BannerContent({ workerId }: { workerId?: string }) {
  const { can } = useAuth();
  const navigate = useNavigate();
  const [items, setItems] = useState<DeregistrationCandidate[]>([]);
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  useEffect(() => {
    const controller = new AbortController();
    void getDeregistrationCandidates(workerId, controller.signal).then(value => {
      if (!controller.signal.aborted) setItems(value);
    }).catch(cause => { if (!controller.signal.aborted) setError(errorMessage(cause, "Provjera potrebnih odjava nije dostupna.")); });
    return () => controller.abort();
  }, [workerId]);
  async function start(item: DeregistrationCandidate) {
    if (busy) return;
    setBusy(true); setError("");
    try { const detail = await startDeregistration(item.worker_id); navigate(`/dozvole/odjave/${detail.process.id}`); }
    catch (cause) { setError(errorMessage(cause, "Odjava nije pokrenuta.")); }
    finally { setBusy(false); }
  }
  return <>{error && <p role="alert">{error}</p>}{items.map(item => <section key={item.worker_id} aria-label="Odjava stranca" className="my-3 space-y-2 rounded-lg border border-orange-500 bg-orange-50 p-4 text-orange-950">
    {!workerId && <Link className="inline-flex min-h-11 items-center font-semibold underline" to={`/zaposlenici/${item.worker_id}`}>{item.worker_name}</Link>}
    <p>{item.process_id ? "Odjava kod policije je u tijeku." : "Radnik ima dozvolu za boravak i rad. Pokreni odjavu kod policije"}</p>
    {item.process_id ? <Link className="inline-flex min-h-11 items-center underline" to={`/dozvole/odjave/${item.process_id}`}>Otvori predmet odjave</Link> : can("dozvola", "update") && <Button className="min-h-11" disabled={busy} onClick={() => void start(item)}>Pokreni odjavu kod policije</Button>}
  </section>)}</>;
}
